module.exports = "/images/trec-preview-2.jpg?8c6adc6670921366f85fbec1596642ea";